/* global jQuery */
// jQuery vem do core do WordPress; o webpack mapeia o modulo para essa global
// via `externals` para nao empacotar uma segunda copia.

import "glider-js/glider.min.css";
import "../scss/index.scss";

import Glider from "glider-js";
import "jquery.marquee";

(function ($) {
  const cursoCarrossel = document.querySelector(".curso-carrossel");
  if (cursoCarrossel) {
    new Glider(cursoCarrossel, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: false,
      arrows: {
        prev: "#prev-curso",
        next: "#next-curso",
      },
      responsive: [
        {
          // screens greater than >= 775px
          breakpoint: 992,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1.5,
          },
        },
      ],
    });
  }

  const listaVagas = document.querySelector(".lista-vagas");
  if (listaVagas) {
    new Glider(listaVagas, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      dots: ".dots",
      responsive: [
        {
          // screens greater than >= 775px
          breakpoint: 768,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 2,
          },
        },
        {
          // screens greater than >= 775px
          breakpoint: 992,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 3,
          },
        },
      ],
    });
  }

  const depoimentos = document.querySelector(".carrossel-depoimentos");
  if (depoimentos) {
    new Glider(depoimentos, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      dots: false,
      arrows: {
        prev: ".carrossel-depoimentos .arrow-prev",
        next: ".carrossel-depoimentos .arrow-next",
      },
      responsive: [
        {
          // screens greater than >= 775px
          breakpoint: 992,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 2,
          },
        },
      ],
    });
  }

  const eventosHome = document.querySelector(".eventos-home .row-eventos");
  if (eventosHome) {
    new Glider(eventosHome, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      dots: false,
      arrows: {
        prev: "#prev-evento",
        next: "#next-evento",
      },
      responsive: [
        {
          // screens greater than >= 775px
          breakpoint: 992,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 2,
          },
        },
      ],
    });
  }

  // Calendario de eventos (template-parts/modulo/evento-calendario.php).
  // Os eventos vem num JSON embutido, entao trocar de mes/ano so remonta a
  // grade no cliente. As datas circulam como string Ymd, o mesmo formato do
  // campo ACF "data", o que deixa a comparacao passado/futuro ser textual.
  const calendario = document.querySelector(".calendario");
  const calendarioDados = calendario
    ? calendario.querySelector(".calendario-dados")
    : null;

  if (calendarioDados) {
    const dados = JSON.parse(calendarioDados.textContent);

    const grade = calendario.querySelector(".calendario-grade");
    const detalhe = calendario.querySelector(".calendario-detalhe");
    const seletorMes = calendario.querySelector(".calendario-seletor-mes");
    const seletorAno = calendario.querySelector(".calendario-seletor-ano");
    const botaoAnterior = calendario.querySelector(".calendario-anterior");
    const botaoProximo = calendario.querySelector(".calendario-proximo");

    const eventosPorDia = {};
    dados.eventos.forEach(function (evento) {
      (eventosPorDia[evento.data] = eventosPorDia[evento.data] || []).push(
        evento,
      );
    });

    const anosComEvento = dados.eventos.map(function (evento) {
      return Number(evento.data.slice(0, 4));
    });
    const anoHoje = Number(dados.hoje.slice(0, 4));
    const anoMin = Math.min(anoHoje, ...anosComEvento);
    const anoMax = Math.max(anoHoje, ...anosComEvento);

    let anoAtual = anoHoje;
    let mesAtual = Number(dados.hoje.slice(4, 6)) - 1;
    let diaSelecionado = eventosPorDia[dados.hoje] ? dados.hoje : null;

    const doisDigitos = function (numero) {
      return String(numero).padStart(2, "0");
    };

    const chaveDia = function (ano, mes, dia) {
      return String(ano) + doisDigitos(mes + 1) + doisDigitos(dia);
    };

    const rotuloData = function (chave) {
      const mes = dados.meses[Number(chave.slice(4, 6)) - 1];
      return (
        Number(chave.slice(6, 8)) + " de " + mes + " de " + chave.slice(0, 4)
      );
    };

    const montarDia = function (dia) {
      if (dia === null) {
        const vazio = document.createElement("div");
        vazio.className = "calendario-dia vazio";
        return vazio;
      }

      const chave = chaveDia(anoAtual, mesAtual, dia);
      const doDia = eventosPorDia[chave] || [];
      const celula = document.createElement(doDia.length ? "button" : "div");

      celula.className = "calendario-dia";

      if (doDia.length) {
        celula.type = "button";
        celula.classList.add("com-evento");
        celula.dataset.data = chave;
        celula.setAttribute(
          "aria-label",
          rotuloData(chave) +
            ": " +
            doDia.length +
            (doDia.length > 1 ? " eventos" : " evento"),
        );
      }

      if (chave === dados.hoje) {
        celula.classList.add("hoje");
      }

      if (chave === diaSelecionado) {
        celula.classList.add("ativo");
      }

      const numero = document.createElement("span");
      numero.textContent = dia;
      celula.appendChild(numero);

      const marcas = document.createElement("span");
      marcas.className = "calendario-marcas";

      // Mais de tres marcas nao cabem na celula e nao acrescentam informacao.
      doDia.slice(0, 3).forEach(function (evento) {
        const marca = document.createElement("span");
        marca.className =
          "calendario-marca " +
          (evento.data >= dados.hoje ? "futuro" : "passado");
        marcas.appendChild(marca);
      });

      celula.appendChild(marcas);

      return celula;
    };

    const montarGrade = function () {
      grade.textContent = "";

      const cabecalho = document.createElement("div");
      cabecalho.className = "calendario-semana";

      dados.diasSemana.forEach(function (nome) {
        const celula = document.createElement("div");
        celula.className = "calendario-cabecalho";
        celula.textContent = nome;
        cabecalho.appendChild(celula);
      });

      grade.appendChild(cabecalho);

      // Completa a primeira e a ultima semana com celulas vazias para a grade
      // continuar retangular.
      const totalDias = new Date(anoAtual, mesAtual + 1, 0).getDate();
      const deslocamento =
        (new Date(anoAtual, mesAtual, 1).getDay() - dados.inicioSemana + 7) % 7;
      const celulas = [];

      for (let i = 0; i < deslocamento; i++) {
        celulas.push(null);
      }

      for (let dia = 1; dia <= totalDias; dia++) {
        celulas.push(dia);
      }

      while (celulas.length % 7 !== 0) {
        celulas.push(null);
      }

      for (let i = 0; i < celulas.length; i += 7) {
        const semana = document.createElement("div");
        semana.className = "calendario-semana";

        celulas.slice(i, i + 7).forEach(function (dia) {
          semana.appendChild(montarDia(dia));
        });

        grade.appendChild(semana);
      }
    };

    const montarDetalhe = function () {
      detalhe.textContent = "";

      const doDia = diaSelecionado ? eventosPorDia[diaSelecionado] : null;
      if (!doDia) {
        return;
      }

      const titulo = document.createElement("p");
      titulo.className = "calendario-detalhe-data";
      titulo.textContent = rotuloData(diaSelecionado);
      detalhe.appendChild(titulo);

      // Reaproveita a marcacao da agenda para o card do evento ficar igual ao
      // da coluna de proximos eventos.
      const lista = document.createElement("ul");
      lista.className = "agenda-lista";

      doDia.forEach(function (evento) {
        const item = document.createElement("li");
        item.className = "agenda-item";

        const link = document.createElement("a");
        link.className = "agenda-link";
        link.href = evento.url;

        const info = document.createElement("div");
        info.className = "agenda-info";

        if (evento.categoria) {
          const categoria = document.createElement("span");
          categoria.className = "agenda-categoria";
          categoria.textContent = evento.categoria;
          info.appendChild(categoria);
        }

        const nome = document.createElement("h3");
        nome.className = "agenda-evento";
        nome.textContent = evento.titulo;
        info.appendChild(nome);

        link.appendChild(info);
        item.appendChild(link);
        lista.appendChild(item);
      });

      detalhe.appendChild(lista);
    };

    const atualizar = function () {
      seletorMes.value = String(mesAtual);
      seletorAno.value = String(anoAtual);
      botaoAnterior.disabled = anoAtual === anoMin && mesAtual === 0;
      botaoProximo.disabled = anoAtual === anoMax && mesAtual === 11;
      montarGrade();
      montarDetalhe();
    };

    const navegar = function (passo) {
      const alvo = new Date(anoAtual, mesAtual + passo, 1);

      if (alvo.getFullYear() < anoMin || alvo.getFullYear() > anoMax) {
        return;
      }

      anoAtual = alvo.getFullYear();
      mesAtual = alvo.getMonth();
      atualizar();
    };

    dados.meses.forEach(function (nome, indice) {
      const opcao = document.createElement("option");
      opcao.value = String(indice);
      opcao.textContent = nome;
      seletorMes.appendChild(opcao);
    });

    for (let ano = anoMin; ano <= anoMax; ano++) {
      const opcao = document.createElement("option");
      opcao.value = String(ano);
      opcao.textContent = ano;
      seletorAno.appendChild(opcao);
    }

    seletorMes.addEventListener("change", function () {
      mesAtual = Number(seletorMes.value);
      atualizar();
    });

    seletorAno.addEventListener("change", function () {
      anoAtual = Number(seletorAno.value);
      atualizar();
    });

    botaoAnterior.addEventListener("click", function () {
      navegar(-1);
    });

    botaoProximo.addEventListener("click", function () {
      navegar(1);
    });

    // Delegacao: a grade e remontada a cada navegacao.
    grade.addEventListener("click", function (evento) {
      const celula = evento.target.closest(".calendario-dia.com-evento");
      if (!celula) {
        return;
      }

      // Clicar de novo no dia ja aberto fecha o detalhe.
      diaSelecionado =
        celula.dataset.data === diaSelecionado ? null : celula.dataset.data;
      atualizar();
    });

    atualizar();
  }

  /*
  const eventosInternos = document.querySelector('.eventos-internos .row-eventos');
  if (eventosInternos) {
    new Glider(eventosInternos, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      dots: false,
      arrows: {
        prev: '#prev-evento-interno',
        next: '#next-evento-interno'
      },
      responsive: [
        {
          // screens greater than >= 775px
          breakpoint: 992,
          settings: {
            slidesToScroll: 'auto',
            slidesToShow: -1
          }
        }
      ]
    });
  }
  */

  /*
  const listaNoticiasRelacionadas = document.querySelector('.row-noticias-relacionadas');
  if (listaNoticiasRelacionadas) {
    new Glider(listaNoticiasRelacionadas, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      dots: false,
      arrows: {
        prev: '.row-noticias-relacionadas .glider-prev',
        next: '.row-noticias-relacionadas .glider-next'
      },
      responsive: [
        {
          // screens greater than >= 775px
          breakpoint: 768,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 2
          }
        },
        {
          // screens greater than >= 775px
          breakpoint: 992,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 3
          }
        },
      ]
    });
  }
  */

  const menu = $(".main-navigation").offset().top;

  $(window).on("scroll load", function () {
    if ($(document).scrollTop() >= menu) {
      $(".site-header").addClass("fixo");
    } else if ($(document).scrollTop() < menu) {
      $(".site-header").removeClass("fixo");
    }
  });

  $(".icone-menu").click(function () {
    $("body").toggleClass("menu-mobile-opened");
  });

  // Galeria da Festa do midia: modal com navegacao e download da foto.
  const $galeriaModal = $("#galeria-modal");

  if ($galeriaModal.length) {
    const $miniaturas = $(".galeria-abrir");
    const $img = $galeriaModal.find(".galeria-modal-img");
    const $legenda = $galeriaModal.find(".galeria-modal-legenda");
    const $download = $galeriaModal.find(".galeria-modal-download");
    const $fechar = $galeriaModal.find(".galeria-modal-fechar");
    let indiceAtual = 0;
    let $origem = null;

    const mostrarFoto = function (indice) {
      // Circula nas pontas: da ultima volta para a primeira e vice-versa.
      const total = $miniaturas.length;
      indiceAtual = ((indice % total) + total) % total;

      const $miniatura = $miniaturas.eq(indiceAtual);
      const legenda = $miniatura.data("galeria-legenda") || "";

      $img.attr("src", $miniatura.data("galeria-url"));
      $img.attr("alt", legenda);
      $legenda.text(legenda);
      $download.attr("href", $miniatura.data("galeria-url"));
      $download.attr("download", $miniatura.data("galeria-arquivo"));
    };

    const abrirGaleria = function (indice) {
      $origem = $miniaturas.eq(indice);
      mostrarFoto(indice);
      $galeriaModal.prop("hidden", false);
      $("body").addClass("galeria-aberta");
      $fechar.trigger("focus");
    };

    const fecharGaleria = function () {
      $galeriaModal.prop("hidden", true);
      $("body").removeClass("galeria-aberta");

      // Devolve o foco para a miniatura que abriu o modal.
      if ($origem) {
        $origem.trigger("focus");
        $origem = null;
      }
    };

    $miniaturas.on("click", function () {
      abrirGaleria($(this).data("galeria-indice"));
    });

    $galeriaModal.on("click", "[data-galeria-fechar]", fecharGaleria);

    $galeriaModal.find(".galeria-modal-anterior").on("click", function () {
      mostrarFoto(indiceAtual - 1);
    });

    $galeriaModal.find(".galeria-modal-proxima").on("click", function () {
      mostrarFoto(indiceAtual + 1);
    });

    $(document).on("keydown", function (evento) {
      if ($galeriaModal.prop("hidden")) {
        return;
      }

      if (evento.key === "Escape") {
        fecharGaleria();
      } else if (evento.key === "ArrowLeft") {
        mostrarFoto(indiceAtual - 1);
      } else if (evento.key === "ArrowRight") {
        mostrarFoto(indiceAtual + 1);
      }
    });
  }

  // Verifica se há query string na url e seta cada valor dentro da Label de cada coluna
  $(".valor-taxonomia").each(function () {
    const valorTaxonomia = $(this).val();
    const nomeTaxonomia = $(this).attr("name");
    $(".label .nome-" + nomeTaxonomia).text($.trim(valorTaxonomia));
  });

  // Altera o valor do input hidden e a label de cada coluna ao clicar em uma opção
  $(".opcoes li").click(function () {
    const valorTaxonomia = $(this).text();
    const nomeTaxonomia = $(this).data("termo");
    const slugTaxonomia = $(this).data("termo-slug");

    $(this).parents(".opcoes").find("li").removeClass("ativo");
    $(this).addClass("ativo");
    $(".nome-" + nomeTaxonomia).text($.trim(valorTaxonomia));

    if (
      slugTaxonomia !== null &&
      slugTaxonomia !== undefined &&
      slugTaxonomia.trim() !== ""
    ) {
      $('input[name="' + nomeTaxonomia + '"]').val($.trim(slugTaxonomia));
    } else {
      $('input[name="' + nomeTaxonomia + '"]').val($.trim(valorTaxonomia));
    }

    $(".form-filtros").submit();
  });

  // Filtro de período da listagem (template-parts/modulo/listagem-filtro.php).
  // A página pode exibir só o mês, só o ano ou os dois. Com JS a troca de
  // qualquer um dos campos já envia o formulário, então o botão sai da página;
  // sem JS ele fica e continua sendo a forma de filtrar.
  const listagemFiltro = $(".listagem-filtro");

  if (listagemFiltro.length) {
    listagemFiltro.find(".listagem-filtro-enviar").remove();

    listagemFiltro.find(".listagem-filtro-seletor").change(function () {
      listagemFiltro.submit();
    });
  }

  // Realiza o scroll após o submit do formulário
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const listaCards = $(".lista-cards");

  // Sem resultado não há lista para onde rolar: o filtro pode não devolver nada.
  if (urlParams.get("scroll") && listaCards.length) {
    $("html, body").animate(
      {
        scrollTop: listaCards.offset().top - 100,
      },
      500,
    );
  }

  $(".accordion-titulo").click(function () {
    $(this).toggleClass("ativo");
    $(this).parent().find(".accordion-conteudo").toggleClass("aberto");
  });

  $(".convidado").click(function () {
    $(this).toggleClass("aberto");
  });

  $(".convidados .fechar").click(function () {
    $(this).parent().prev(".convidado").removeClass("aberto");
  });

  $(".faixa-1").marquee({
    //duration in milliseconds of the marquee
    duration: 15000,
    //time in milliseconds before the marquee will start animating
    delayBeforeStart: 0,
    //'left' or 'right'
    direction: "right",
    //true or false - should the marquee be duplicated to show an effect of continues flow
    duplicated: false,
  });

  $(".faixa-2").marquee({
    //duration in milliseconds of the marquee
    duration: 15000,
    //time in milliseconds before the marquee will start animating
    delayBeforeStart: 0,
    //'left' or 'right'
    direction: "left",
    //true or false - should the marquee be duplicated to show an effect of continues flow
    duplicated: false,
  });
})(jQuery);
